const STORAGE_KEY = "ashtang-theme";

export function getSavedTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    return null;
  }
  return null;
}

export function getPreferredTheme() {
  return getSavedTheme() || "light";
}

export function applyTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme);
  document.documentElement.style.colorScheme = theme;
}

export function getTheme() {
  return document.documentElement.getAttribute("data-theme") || getPreferredTheme();
}

function broadcast(theme) {
  window.dispatchEvent(new CustomEvent("ashtang-theme", { detail: theme }));
}

export function setTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* preference still applies for this visit */
  }
  applyTheme(theme);
  broadcast(theme);
  return theme;
}

export function toggleTheme() {
  return setTheme(getTheme() === "dark" ? "light" : "dark");
}

export function initTheme() {
  applyTheme(getPreferredTheme());
  const media = window.matchMedia("(prefers-color-scheme: dark)");
  const onChange = (event) => {
    if (getSavedTheme()) return;
    const theme = event.matches ? "dark" : "light";
    applyTheme(theme);
    broadcast(theme);
  };
  if (media.addEventListener) media.addEventListener("change", onChange);
  else media.addListener(onChange);
}
